import { useEffect, useState } from 'react';
import axios from 'axios';
import { OptionSet } from '../models/SkillsInterfaces';

export const useGetAllCategories = () => {
  const [categories, setCategories] = useState<OptionSet[]>([]);
  const [loadingCategories, setLoadingCategories] = useState(true);

  const getAllCategories = async () => {
    setLoadingCategories(true);
    try {
      const response = await axios.get('api/option-sets/skill-categories');
      setCategories(response.data);
    } catch (error) {
      console.error(error);
    } finally {
      setLoadingCategories(false);
    }
  };

  useEffect(() => {
    getAllCategories();
  }, []);

  return { categories, loadingCategories };
};
